import { Stock } from './Stock';

export class CartItem {
    constructor (public stock: Stock, public qty: number) {}

    public toStorage (): { stockId: number, qty: number } {
        return { stockId: this.stock.id, qty: this.qty };
    }
}
